// 지출결의 내역 표의 열 정의 — 계좌이체(원화)와 외화송금이 서로 다른 열을 쓴다.
// 전자결재(Streamlit) ingest.COLS / ingest.FX_COLS 와 같은 순서라 엑셀 양식이 그대로 호환된다.
export const FX_FORM = '지출결의서_외화송금'
export const CURRENCIES = ['USD', 'CNY', 'AUD']

const F = {
  vendor: { key: 'vendor', label: '거래처', width: 150, aliases: ['거래처명', '거래처', '지급처', '업체명', '업체', '상호명', '상호'] },
  account_cat: { key: 'account_cat', label: '계정과목', width: 130, aliases: ['계정과목명', '계정과목', '계정명', '계정', '과목'] },
  detail: { key: 'detail', label: '적요', width: 170, aliases: ['지출내용', '거래내용', '적요', '내용', '사유', '사용내역', '내역'] },
  bank: { key: 'bank', label: '은행', width: 90, aliases: ['은행명', '금융기관', '은행'] },
  swift: { key: 'swift', label: 'SWIFT code', width: 110, aliases: ['swiftcode', 'swift', '스위프트코드', '스위프트'] },
  account: { key: 'account', label: '계좌번호', width: 150, aliases: ['계좌번호', '입금계좌', '계좌'] },
  holder: { key: 'holder', label: '예금주', width: 100, aliases: ['예금주명', '예금주', '수취인명', '수취인'] },
  currency: { key: 'currency', label: '통화', width: 80, aliases: ['통화', '화폐', 'currency'] },
  amount: { key: 'amount', label: '금액', width: 110, aliases: ['지급금액', '지급액', '지출금액', '지급요청금액', '금액'] },
}

export const KRW_FIELDS = [F.vendor, F.account_cat, F.detail, F.bank, F.account, F.holder, F.amount]
export const FX_FIELDS = [F.vendor, F.account_cat, F.detail, F.bank, F.swift, F.account, F.holder, F.currency, F.amount]

export const isFxForm = (formType) => formType === FX_FORM
export const fieldsFor = (formType) => (isFxForm(formType) ? FX_FIELDS : KRW_FIELDS)

export const EMPTY_LINE = {
  vendor: '', account_cat: '', detail: '', bank: '', swift: '',
  account: '', holder: '', currency: '', amount: '',
}
